import { StatusCadastro } from '../shared/enums/status-cadastro.enum';

export class DepartamentoCadastro {
    public status: StatusCadastro;
    constructor(
        public codigo: string,
        public nome: string
    ) {}
}
